module.exports = __webpack_public_path__ + "assets/img/25_435_big.f145ca6c.jpg";